<template>
    <ProductListing
        v-if="content.data?.listing"
        :data="content.data.listing"
        :extensions="content.extensions"
        :show-subcategories-on-mobile="content.config?.showSubcategoriesOnMobile?.value ?? false"
    />
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'

defineProps<{
    content: Schemas['CmsElementProductListing']
}>()
</script>
